import { BadgeLevel } from '../badge-level'
import { BadgeLuckyHero } from '../badge-lucky-hero'
import { BadgeReseller } from '../badge-reseller'
import { BadgeSuperRich } from '../badge-super-rich'
import { BadgeVip } from '../badge-vip'
import { BadgeAgency } from '../bagde-agency'

interface Props {
  level?: string | number
  vipId?: number
  agencyLevel?: number
  resellerLevel?: number
  luckyHero?: boolean
  superRich?: boolean
}

export function BadgeIcons({
  vipId,
  level,
  agencyLevel,
  resellerLevel,
  luckyHero,
  superRich,
}: Props) {
  if (
    vipId ||
    level ||
    agencyLevel ||
    resellerLevel ||
    luckyHero ||
    superRich
  ) {
    return (
      <span className="inline-flex max-w-full flex-wrap items-center gap-1 align-middle">
        {level && <BadgeLevel level={level} />}
        {vipId && <BadgeVip vipId={vipId} />}
        {agencyLevel && <BadgeAgency agencyLevel={agencyLevel} />}
        {resellerLevel && <BadgeReseller resellerLevel={resellerLevel} />}
        {luckyHero && <BadgeLuckyHero luckyHero={luckyHero} />}
        {superRich && <BadgeSuperRich superRich={superRich} />}
      </span>
    )
  }
}
